import React, { useState } from "react";
import { Upload, Button, message, Progress } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { SCORM_GENERATE_PRESIGNED_URL } from "../apis/apis";

const ScormUploader = ({ set_fileKey, setUploadingStatus }) => {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [video_uploading_message,set_video_uploading_message] = useState("")
    

    const handleUpload = async ({ file, onSuccess, onError }) => {
        try {
           setUploading(true);
setUploadingStatus(true);
setProgress(0);
            const FORM_DATA = new FormData();
            FORM_DATA.append("scrom_file", file.name);
            const response = await SCORM_GENERATE_PRESIGNED_URL(FORM_DATA);
            if (response?.data?.status) {
                await axios.put(response?.data?.uploadUrl, file, {
                    headers: {
                        "Content-Type": "application/zip",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        if (percent >= 100) {
                            set_video_uploading_message("Uploading and Verifying...");
                        }

                        setProgress(percent >= 100 ? 99 : percent);

                    },
                });
               set_fileKey(response?.data?.fileKey);
setProgress(100);

setTimeout(() => {
    setUploading(false);
    setUploadingStatus(false);
}, 1000);

onSuccess("ok");
return;
            }
        }
       catch (err) {
    console.error(err);
    setUploading(false);
    setUploadingStatus(false);
    message.error("Upload failed!");
    onError(err);
}
    };

    return (
        <div>
            <Upload
                accept=".zip"
                maxCount={1}
                customRequest={handleUpload}
                showUploadList={{ showRemoveIcon: false }}
            >
                <Button icon={<UploadOutlined />} loading={uploading}>
                    Upload SCORM Package
                </Button>
            </Upload>

            {uploading && <Progress percent={progress} size="small" />}
           {progress === 99 && (
  <p
    style={{
      color: "orange",
      marginTop: "10px",
      marginBottom: 0,
    }}
  >
    {video_uploading_message}
  </p>
)}

{progress === 100 && (
  <p
    style={{
      color: "rgb(101, 231, 196)",
      marginTop: "10px",
      marginBottom: 0,
      fontWeight: 500,
    }}
  >
    Upload successful & verified
  </p>
)}
        </div>
    );
};

export default ScormUploader;
